import type { RefObject } from "react";
import { useEffect } from "react";

import useLatestValue from "app/custom-hooks/useLatestValue";

import { subscribeScrollDismiss } from "./scrollDismissRegistry";

/**
 * Closes an open popover when one of `anchorRef`'s scrollable ancestors scrolls. `anchorRef` must point
 * to an element inside the popover's own scroll subtree (its trigger) — see ScrollDismissBoundary.
 */
export function useCloseOnScroll(isOpen: boolean, onClose: VoidFunction, anchorRef: RefObject<Element | null>): void {
    const onCloseRef = useLatestValue(onClose);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        return subscribeScrollDismiss({ anchorRef, onClose: () => onCloseRef.current() });
    }, [isOpen, anchorRef, onCloseRef]);
}
